import { FETCH_REQUEST_ACTION_TYPE, } from '../../jsCore/application/sagas/fetchSaga';
import { getApiEndpoints, } from '../../jsCore/application/api';
import { memoizeFirstCall, } from '../../jsCore/utils/fn';


export const API_ENDPOINT_NAME = 'FANVOICE';
 
const FANVOICE_CLIENT_SIDE_TYPES = {
  TWITTER_IMAGE: 'twitter-image',
  TWITTER_NO_CONTENT: 'only-image',
};

function getFanvoiceItemType(image, fanvoiceItemType){
  switch (fanvoiceItemType) {
    case 'fanvoice':
      return FANVOICE_CLIENT_SIDE_TYPES.TWITTER_NO_CONTENT;
    case 'twitter':
      return image ? FANVOICE_CLIENT_SIDE_TYPES.TWITTER_IMAGE : fanvoiceItemType;
    default:
      return fanvoiceItemType;
  }
}

function transformFanvoiceData({ items, }){
  return {
    fanvoiceItems: items.map(item => {
      const {
        type,
        link,
        content,
        image_path: image,
        author: authorData,
      } = item;
      const author = authorData && {
        image: authorData.image,
        fullname: authorData.full_name,
        username: authorData.username,
      };
      return {
        link,
        image,
        author,
        content,
        type: getFanvoiceItemType(image, type),
      };
    })
  };
}

function fetchFanvoice(){
  const {
    fanvoiceEndpoint: { url, endpointName, },
  } = memoizeFirstCall('fanvoiceEndpoint', getApiEndpoints, API_ENDPOINT_NAME);
  return {
    type: FETCH_REQUEST_ACTION_TYPE,
    payload: {
      url,
      endpointName,
      dataTransformer: transformFanvoiceData,
      additionalState: {
        IS_INITIALIZED: true,
      },
    },
  };
}

export const fanvoiceActions = { fetchFanvoice, };


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/fanvoiceActions.js